import { getSubscriptionEventsNext, getModalSubscriptionEventsNext } from './actionType';

const initialState = {
  subscriptionEvents: null,
  modalSubscriptionEvents: null,
}

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getSubscriptionEventsNext.INIT:
      return { ...state, subscriptionEvents: null }
    case getSubscriptionEventsNext.SUCCESS:
      return { ...state, subscriptionEvents: payload }
    case getModalSubscriptionEventsNext.INIT:
      return { ...state, modalSubscriptionEvents: null }
    case getModalSubscriptionEventsNext.SUCCESS:
      return { ...state, modalSubscriptionEvents: payload }
    default:
      return state
  }
}
